import React from "react";
import set from "lodash/set";
import {observable, toJS} from "mobx";
import CollectorContext from "../contexts/CollectorContext";
import ModelContext from "../contexts/ModelContext";

export default class Collector extends React.Component {

    static contextType = ModelContext;

    @observable data = {};
    model = observable.map();

    setValue(path, value) {
        set(this.data, path, value);
        this.model.replace(this.data);
    }

    render() {
        return (
            <CollectorContext.Provider value={this}>
                <React.Fragment>
                    {this.props.children}
                </React.Fragment>
            </CollectorContext.Provider>
        )
    }

}
